// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"74":"5fbd3c41","224":"944ace69","380":"1e6c7133","453":"f6ed8d92","701":"2855c402","942":"7055e50d"}[chunkId] + ".chunk.js";
};